module.exports = __webpack_public_path__ + "static/media/8.600c5a1e.jpg";